export default "__VITE_ASSET__bca6fe16__"